<template>
  <div v-if="showBadges" :class="['collection-card-badges', { small }]">
    <badge v-if="quantity > 1" icon="tag" :label="quantityLabel" />
    <badge v-if="card.sold" icon="attach_money" :label="soldLabel" />
    <badge
      @click.native="$emit('clickEstimation')"
      v-if="activeValueEstimation"
      :icon="typeIcon"
      :label="typeLabel"
      clickable
    />
  </div>
</template>

<script>
import { COLLECTION_CARD_ESTIMATE_OPTIONS } from '../constants';

import Badge from './Badge';

export default {
  components: {
    Badge,
  },

  props: {
    card: Object,
    small: Boolean,
  },

  computed: {
    showBadges() {
      return Boolean(this.card.collectionCardId);
    },

    quantity() {
      const quantity = this.card.sold
        ? this.card.quantity - this.card.quantitySold
        : this.card.quantity;

      return parseInt(quantity, 10) || 0;
    },

    quantityLabel() {
      return this.small ? `${this.quantity}` : `Quantity: ${this.quantity}`;
    },

    soldLabel() {
      return this.small ? '' : `Sold${this.card.quantity > 1 ? `: ${this.card.quantitySold}` : ''}`;
    },

    hasCompleteMultiplier() {
      return Boolean(this.card?.multipliers?.some(({ card, value }) => Boolean(card && value)));
    },

    hasCompleteAdvanced() {
      return Boolean(this.card?.playerIndexPrice && this.card?.playerIndexDate && (this.card?.playerIndexId || this.card?.otherIndexId));
    },

    hasCompletedGradedCardInfo() {
      return this.card?.profileId && this.card?.grade && this.card?.grader;
    },

    activeValueEstimation() {
      let id = null;

      if (this.card?.cardId) {
        id = 'ladder';
      } else if (Boolean(this.card?.ebayQuery) && this.card?.useSalesForValue) {
        id = 'lastsale';
      } else if (this.hasCompletedGradedCardInfo && this.card?.useGradedCardAutomatic) {
        id = 'gradedcardautomatic';
      } else if (this.hasCompleteAdvanced) {
        id = 'advanced';
      } else if (this.hasCompleteMultiplier) {
        id = 'multipliers';
      } else if (this.card?.playerIndexId) {
        id = 'playerindex';
      } else if (this.card?.estimatedCurrentValue) {
        id = 'manual';
      }

      return COLLECTION_CARD_ESTIMATE_OPTIONS.find((estimateOption) => estimateOption.id === id);
    },

    typeIcon() {
      return this.activeValueEstimation ? this.activeValueEstimation.icon : 'cl_ladder';
    },

    typeLabel() {
      if (this.small) {
        return '';
      }

      return this.activeValueEstimation ? this.activeValueEstimation.title : 'Ladder';
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../scss/variables.scss';

.collection-card-badges {
  display: flex;
  flex-wrap: wrap;

  &:not(.small) {
    margin-top: $gp;
  }

  > *:not(:last-child) {
    margin-right: $gp * .5;
  }

  &:not(.small) {
    > * {
      margin-bottom: $gp * .5;
    }
  }
}
</style>
